import { FilterFormat } from "@iventis/types/api.types";
import { Asset } from "@iventis/domain-model/model/asset";
import { PagedResult } from "@iventis/domain-model/model/pagedResult";
import { Model } from "@iventis/domain-model/model/model";
import { AssetType } from "@iventis/domain-model/model/assetType";
import { AssetCategory } from "@iventis/domain-model/model/assetCategory";
import { Hierarchy } from "@iventis/domain-model/model/hierarchy";
import { UploadIconData, UploadModelData, UploadModelImageData } from "@iventis/types/model-types";

export interface IAssetService {
    getAsset: (assetId: string, suppressErrors?: boolean) => Promise<Asset>;
    getAssetTags: (tagType: AssetType) => Promise<Hierarchy<AssetCategory>[]>;
    getAssetsByType: (pageNumber: number, assetType: AssetType, filters: FilterFormat[]) => Promise<PagedResult<Asset[]>>;
    getAssetsById: (ids: string[]) => Promise<Asset[]>;
    getCdnAsset: <T>(url: string) => Promise<T>;
    postIcon: (data: UploadIconData) => Promise<Asset>;
    patchIcon: (data: UploadIconData, existingAsset: Asset) => Promise<Asset>;
    postModel: (data: UploadModelData) => Promise<Model & { thumbnail: Asset }>;
    updateModel: (updated: UploadModelData, original: UploadModelData) => Promise<Model>;
    deleteAsset: (assetId: string) => Promise<void>;
    assetPagination?: boolean;
    hideAssetSelectorActions?: boolean;
    canEditAsset: (asset: Asset) => boolean;
    getRecommendedCategories: (assetType: AssetType) => Promise<AssetCategory[]>;
    postModelImage: (data: UploadModelImageData) => Promise<Asset>;
}
